// services
import db from '@/services/db'

export default {
  async access_getDashboardsAccess({ state, commit }) {
    commit(
      'access_setDashboardAccess',
      await db.dashboards.access(state.userId)
    )
  },
}
